import { useCallback, useEffect, useState } from 'react';

export function useDismissableCard(
  userId: string,
  isDismissedFn: (userId: string) => Promise<boolean>,
  dismissFn: (userId: string) => Promise<void>,
): {
  visible: boolean;
  dismissing: boolean;
  onDismiss: () => Promise<void>;
} {
  const [visible, setVisible] = useState(false);
  const [dismissing, setDismissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const dismissed = await isDismissedFn(userId);
      if (!cancelled && !dismissed) setVisible(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, isDismissedFn]);

  const onDismiss = useCallback(async () => {
    setDismissing(true);
    try {
      await dismissFn(userId);
      setVisible(false);
    } finally {
      setDismissing(false);
    }
  }, [userId, dismissFn]);

  return { visible, dismissing, onDismiss };
}
